<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Condición Particular
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="onNuevo">Nuevo</v-btn>
            <ModalCondicionParticularComponent :listGeneral="listGeneral" />
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Aseguradora *" color="textbox" v-model="objConSearch.idAseguradora"
                        :items="listGeneral.listAseguradora" item-text="aseguradora" item-value="idAseguradora"
                        @change="onListarPoliza($event,true)" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Póliza *" color="textbox" v-model="objConSearch.idPoliza"
                        :items="listGeneral.listPoliza" item-text="poliza" item-value="id_poliza"
                        @change="onListarProducto($event,true)" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Producto *" color="textbox" v-model="objConSearch.idProducto"
                        :items="listGeneral.listProducto" item-text="nombre_producto" item-value="id_producto"
                        @change="onListarClasificacionProducto($event,true);onListarCondicionParticular($event,true)"
                        outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Seguro" color="textbox" :placeholder="objConSearch.seguro" filled dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Naturaleza" color="textbox" :placeholder="objConSearch.naturaleza" filled dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Regulación" color="textbox" :placeholder="objConSearch.regulacion" filled dense readonly />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4"></v-col>
                <v-col cols="12" sm="4"></v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado *" color="textbox" v-model="objConSearch.idEstado"
                        :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado"
                        @change="onListarCondicionParticular($event,true)" outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6" />
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" prepend-inner-icon="search" dense v-model="objConSearch.search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="objConSearch.search" :headers="listGeneral.cabecera"
                        :items="listGeneral.detalle" class="elevation-3">

                        <template v-slot:item.secOrdenNue="{ item }">
                            <v-autocomplete color="textbox" class="mt-3" v-model="item.secOrdenNue"
                                :items="listOrdenamiento" item-text="orden" item-value="secOrden"
                                @change="onOrdenar(item)" outline />
                        </template>

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="objConSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row dense class="mt-5" v-show="_.size(listGeneral.detalle) > 0">
                <v-col cols="12">
                    <v-row dense>
                        <v-col class="text-center">
                            <v-btn rounded dark color="primary" @click="insertarActualizar(true)"
                                v-html="'Guardar Nuevo Orden'" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        components:{
            ModalCondicionParticularComponent: () => import('@/components/constructor/condicion/ModalCondicionParticularComponent.vue')
        },
        name: 'CondicionParticularView',
        data: () => ({
            objConSearch: {},
            objConForm: {},
            listGeneral: {},
            listParametros: {},
        }),
        created() {
            axios.post(`${BASE_URI}administrador/condicion-particular/cargaGeneral`,{})
                 .then((r) =>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        this.listGeneral = r.data.data.listas;
                        this.listParametros = r.data.data.listParametros;
                        this.objConSearch = {
                            idEstado: _.toString(this.listParametros.idEstadoDefault),
                            idAseguradora: this.listGeneral.listAseguradora[0].idAseguradora
                        };
                        this.objConForm = {};
                        this.cargaGeneral();
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,'E');
                 })
        },
        computed: {
            listOrdenamiento() {
                var lista = _.clone(_.get(this.listGeneral, 'listOrden', []));

                lista = _.filter(lista, (v) => {
                    if (_.size(_.find(this.listGeneral.detalle, (obj) => {
                            return parseInt(obj.secOrden) == parseInt(v.secOrden);
                        })) > 0)
                        return v;
                });
                return lista;
            }
        },
        methods: {
            apiSend(url, objeto) {
                return axios.post(`${BASE_URI}${url}`, objeto);
            },
            cargaGeneral() {
                this.onListarPoliza('L', false, true)
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            return this.onListarProducto('L', false, true);
                    })
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            return this.onListarClasificacionProducto('L', false);
                    })
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            return this.onListarCondicionParticular('L', false);
                    })
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    });
            },
            onListarPoliza(event, isActive = false, nuevo = false) {
                if (!_.isUndefined(event)) {
                    var objeto = _.merge({},{opcion: 'LISTAR'},_.pick(this.objConSearch,['idAseguradora','idEstado']));
                    this.$set(this.listGeneral, 'listPoliza', []);

                    var p = this.apiSend('administrador/poliza/listar', objeto)
                                .then((r) => {
                                    if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r,['data','data'],[])) > 0) {
                                        this.$set(this.listGeneral, 'listPoliza', r.data.data);
                                        if (nuevo)
                                            this.$set(this.objConSearch, 'idPoliza', this.listGeneral.listPoliza[0].id_poliza);
                                    } else if (isActive)
                                        mensajesAlerta(r.data.mensaje, 'I');
                                    return r;
                                });

                        if (isActive)
                            p.catch((e) => {
                                mensajesAlerta(e, 'E');
                            });

                    return p;
                }
            },
            onListarProducto(event, isActive = false, nuevo = false) {
                if (!_.isUndefined(event)) {
                    var objeto = _.merge({},{opcion: 'L_COMBO'},_.pick(this.objConSearch,['idAseguradora','idPoliza','idEstado']));
                    this.$set(this.listGeneral, 'listProducto', []);

                    var p = this.apiSend('administrador/producto/listar', objeto)
                                .then((r) => {
                                    if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(r.data.data) > 0) {
                                        this.$set(this.listGeneral, 'listProducto', r.data.data);
                                        if (nuevo)
                                            this.$set(this.objConSearch, 'idProducto', r.data.data[0].id_producto);
                                    } else if (isActive)
                                        mensajesAlerta(r.data.mensaje, 'I');
                                    return r;
                                });

                        if (isActive)
                            p.catch((e) => {
                                mensajesAlerta(e, 'E');
                            });

                    return p;
                }
            },
            onListarClasificacionProducto(event, isActive) {
                if (!_.isUndefined(event)) {
                    this.objConSearch.seguro = null;
                    this.objConSearch.naturaleza = null;
                    this.objConSearch.regulacion = null;

                    var p = this.apiSend('administrador/producto/listar', { opcion: 'DETALLE', idProducto: _.get(this.objConSearch, 'idProducto', null) })
                                .then((r) => {
                                    if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(r.data.data) > 0) {
                                        this.objConSearch = _.merge({}, this.objConSearch, r.data.data[0]);
                                    } else if (isActive)
                                        mensajesAlerta(r.data.mensaje, 'I');
                                    return r;
                                });

                    if (isActive)
                        p.catch((e) => {
                            mensajesAlerta(e, 'E');
                        });

                    return p;
                }
            },
            onListarCondicionParticular(event, isActive = false) {
                if (!_.isUndefined(event)) {
                    var objeto = _.merge({},{opcion: 'LISTAR'},_.pick(this.objConSearch,['idProducto','idEstado']));
                    this.$set(this.listGeneral, 'detalle', []);

                    var p = this.apiSend('administrador/condicion-particular/listar', objeto)
                        .then((r) => {
                            if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(r.data.data) > 0){
                                var l = _.map(r.data.data, (v) => { v.index = _.uniqueId(); v.secOrdenNue = v.secOrden; return v; });
                                this.$set(this.listGeneral, 'detalle', l);
                            }
                            else if (isActive)
                                mensajesAlerta(r.data.mensaje, 'I');
                            return r;
                        });

                    if (isActive)
                        p.catch((e) => {
                            mensajesAlerta(e, 'E');
                        });

                    return p;
                }
            },
            onNuevo() {
                //Reset data
                this.$children[0].$children[11].cargaGeneral(false);
                this.$children[0].$children[11].cargaGeneral(true);
                this.$children[0].$children[11].objFormConParModal.abrirModal = true;
            },
            onEditar(objeto) {
                this.$children[0].$children[11].objFormConParModal = _.merge({}, objeto, { abrirModal: true, titulo: 'Editar Condición Particular' });
                this.$children[0].$children[11].orden = true;
                this.$children[0].$children[11].cargaGeneral(true);
            },
            onOrdenar(objeto) {
                var obj = _.clone(objeto);
                var detalle = _.clone(this.listGeneral.detalle);
                var posAct = _.findIndex(this.listGeneral.detalle, (v) => { return parseInt(v.secOrden) == parseInt(obj.secOrden) });
                var posCam = _.findIndex(this.listGeneral.detalle, (v) => { return parseInt(v.secOrden) == parseInt(obj.secOrdenNue) });

                this.listGeneral.detalle[posAct].secOrden = obj.secOrdenNue;
                this.listGeneral.detalle[posAct].secOrdenNue = obj.secOrdenNue;
                this.listGeneral.detalle[posCam].secOrden = obj.secOrden;
                this.listGeneral.detalle[posCam].secOrdenNue = obj.secOrden;

            },
            insertarActualizar(cambiarOrden = false) {
                if (cambiarOrden) {
                    this.apiSend('administrador/condicion-particular/insertOrUpdate', {
                            opcion: 'UM',
                            'detalle': this.listGeneral.detalle
                        })
                        .then((r) => {
                            if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if (r.data.existeError) throw mensajeEstandar.errorPeticion;
                                mensajeAlertaTiempo(r.data.mensaje,'S');
                                this.$children[0].$children[11].cargaGeneral(false);
                                return this.onListarCondicionParticular('L');
                        })
                        .catch((e) => {
                            mensajesAlerta(e, 'E');
                        })
                } else {
                    this.apiSend('administrador/condicion-particular/insertOrUpdate', this.objConForm)
                        .then((r) => {
                            if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if (r.data.existeError) throw mensajeEstandar.errorPeticion;
                                mensajeAlertaTiempo(r.data.mensaje,'S');
                                this.$children[0].$children[11].cargaGeneral(false);
                                return this.onListarCondicionParticular('L');
                        })
                        .catch((e) => {
                            mensajesAlerta(e, 'E');
                        })
                }
            }
        }
    }
</script>

<style>

</style>